var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "b-badge",
        {
          staticStyle: { padding: "0px", "margin-left": "5px" },
          attrs: {
            id: "guide-text-" + _vm.contentType + "-" + _vm.conditionType,
            variant: "light-secondary",
            hover: "",
          },
        },
        [_c("feather-icon", { attrs: { icon: "InfoIcon" } })],
        1
      ),
      _c(
        "b-tooltip",
        {
          attrs: {
            target: "guide-text-" + _vm.contentType + "-" + _vm.conditionType,
            placement: "right",
            variant: "dark",
          },
        },
        _vm._l(_vm.displayNodeList, function (node, index) {
          return _c("dd", { key: index, staticClass: "text-left m-0" }, [
            _vm._v(
              " " +
                _vm._s(
                  node.formName +
                    " ▶ " +
                    node.routedPageName +
                    " ▶ [ " +
                    node.displayNode +
                    " ]"
                ) +
                " "
            ),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }